module.exports = __webpack_public_path__ + "img/Luonan_Chen.e83e9321.png";